import { Button } from "@mui/material";
import { type FC, Fragment } from "react";
import type { PollButtonProps } from "../../../utils/convert-to-mjml/poll-buttons/types";

export const VerticalPollOptions: FC<Omit<PollButtonProps, "align">> = ({
  buttonType,
  options,
  buttonWidth,
}) => {
  return (
    <Fragment>
      {options.map((option) => (
        // eslint-disable-next-line ce/require-button-id
        <Button
          className={buttonType}
          key={option.text}
          sx={{ cursor: "default", width: buttonWidth }}
        >
          {option.text}
        </Button>
      ))}
    </Fragment>
  );
};
